import $ from 'jquery'
import Isotope from 'isotope-layout'
// @ts-ignore
import jQueryBridget from 'jquery-bridget'
jQueryBridget('isotope', Isotope, $)

$('.row-masonry').isotope({})
